<form [formGroup]="greenCardForm()">
  <h2>Är du innehavare av amerikanskt uppehålls- och
    arbetstillstånd? (s.k. Green card)</h2>
  <p class="select-title">Vänligen välj:</p>

  <mat-radio-group
    tabindex="0"
    class="column"
    [class.selection-error]="greenCardForm().get('greenCard')?.invalid && greenCardForm().get('greenCard')?.touched"
    formControlName="greenCard"
    aria-required="true"
    [attr.aria-invalid]="greenCardForm().get('greenCard')?.invalid && greenCardForm().get('greenCard')?.touched"
    [attr.aria-describedby]="greenCardForm().get('greenCard')?.invalid && greenCardForm().get('greenCard')?.touched ? 'greencard-error' : null">
    <mat-radio-button [value]="true">Ja</mat-radio-button>
    <mat-radio-button [value]="false">Nej</mat-radio-button>
  </mat-radio-group>

  @if (greenCardForm().controls.greenCard.errors && greenCardForm().controls.greenCard.touched) {
    <div class="mat-error-container">
      <mat-icon aria-hidden="true" class="negative">priority_high</mat-icon>
      <mat-error id="greencard-error">Vänligen gör ett val</mat-error>
    </div>
  }
</form>